import { SemanticSIZES } from "semantic-ui-react";

export const GTM_ID: string = 'G-GVCCTTBKXV';
export const ROUTE_ALERT_APP_URL: string = 'https://wsdot.wa.gov/Ferries/RouteAlerts';
export const BUTTON_SIZE: SemanticSIZES = 'big';
export const BUTTON_SIZE_MOBILE: SemanticSIZES = 'large';
export const DRAGON_ANNOUNCE: string = 'dragonAnnounce'; // localstorange for announcement
export const DRAGON_ANNOUNCE_VERSION: number = 1.0; // localstorange for announcement
